<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16.5"
    height="16.5"
    viewBox="0 0 16.5 16.5"
  >
    <path
      id="Icon_map-search"
      data-name="Icon map-search"
      d="M13.514,11.318a6.525,6.525,0,1,0-2.2,2.195l4.427,4.427,2.2-2.2Zm-5.563.66a4.025,4.025,0,1,1,4.027-4.023A4.032,4.032,0,0,1,7.95,11.978Z"
      transform="translate(-1.44 -1.44)"
    />
  </svg>
</template>

<script>
export default {
  name: 'SearchIcon',
};
</script>
